export default function getAssignmentById({assignmentList, assignmentId}) {
  let selectedAssignment
  assignmentList.forEach((assignment) => {
    if (assignment.assignmentId === assignmentId) {
      selectedAssignment = assignment
    }
  })
  return selectedAssignment
}


// WEBPACK FOOTER //
// ./src/helpers/getAssignmentById.js